import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * buyers.length));
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed) return;
    const schedule = (delay: number) => {
      const showId = window.setTimeout(() => {
        setVisible(true);
        const hideId = window.setTimeout(() => {
          setVisible(false);
          const nextId = window.setTimeout(() => {
            setIndex(i => (i + 1) % buyers.length);
            schedule(GAP);
          }, 300);
          timers.current.push(nextId);
        }, VISIBLE_FOR);
        timers.current.push(hideId);
      }, delay);
      timers.current.push(showId);
    };
    schedule(FIRST_DELAY);
    return () => {
      timers.current.forEach(id => window.clearTimeout(id));
      timers.current = [];
    };
  }, [dismissed]);
  const buyer = buyers[index];
  const initial = buyer.name.replace(/^Dra?\.\s/, '').charAt(0);
  return <div className="pointer-events-none fixed inset-x-3 bottom-[96px] z-50 sm:inset-x-auto sm:left-5 sm:w-[360px] lg:bottom-6" aria-live="polite" data-id="element-59" data-mp="1ax7l8xg76owc">
      <AnimatePresence data-id="element-60" data-mp="i8a6h4b73a8c">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-[0_20px_40px_-16px_rgba(5,14,36,0.5)]" data-id="element-61" data-mp="ia4syn247aej">
            <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-lg font-black text-white" data-id="element-62" data-mp="2apcows6s0ne8">
              {initial}
              <span className="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white bg-cta" data-id="element-63" data-mp="2kn0obvfbuj2q">
                <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" data-id="element-64" data-mp="2plby665mgtky" />
              </span>
            </span>
            <div className="min-w-0 text-sm leading-snug" data-id="element-65" data-mp="1rvz3pesv7vbt">
              <p className="text-navy" data-id="element-66" data-mp="1wy7xgddkb1ez">
                <strong data-id="element-67" data-mp="1wv2bh708cfnh">{buyer.name}</strong> from {buyer.place}
              </p>
              <p className="text-navy/70" data-id="element-68" data-mp="21uoj90xah3ow">just purchased the Torque Control Blueprint™</p>
              <p className="mt-0.5 text-xs font-semibold text-[#12A863]" data-id="element-69" data-mp="26nrfxhxd4t9b">
                {buyer.minutesAgo} {buyer.minutesAgo === 1 ? 'minute' : 'minutes'} ago · Verified
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-navy/40 transition-colors duration-150 hover:text-navy" aria-label="Close notification" data-id="element-70" data-mp="1e542moolyiis">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="3ieyxiorpz6bm" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}